import { mutatorAction } from 'satcheljs';
import { bizchatSidepaneStore } from '../store/store';
import { UserCohort } from 'owa-bizchat-types/lib/UserCohort';
import type { AccountKey } from 'owa-client-types';
import type { Eligibility } from 'owa-graph-schema';
/**
 * This is meant to be an atomic mutator to update the bizchat acquisition state for a mailbox
 * @param accountKey The account key for which to update the bizchat state
 * @param hasAcquisition Whether the mailbox has the acquisition from MOS3
 * @param title The title object from the acquisition to extract cohort and isCopilotEligible
 */
export const updateBizchatEnabledMutator: (
    accountKey: AccountKey,
    hasAcquisition: boolean,
    eligibility?: Eligibility
) => void = mutatorAction(
    'updateBizchatEnabledMutator',
    (accountKey, hasAcquisition, eligibility) => {
        bizchatSidepaneStore().hasBizchatAcquisitionMap.set(accountKey, {
            hasAcquisition,
            userCohort: (eligibility?.cohort?.toLowerCase() as UserCohort) ?? UserCohort.None,
            isCopilotEligible: eligibility?.isCopilotEligible ?? true,
        });
    }
);
